module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/swiss_national_day-3467ca7750f939514be59ce7d11528c3.svg";